"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireWildcard(require("../../../../../ui/Button"));
var _withProps = _interopRequireDefault(require("./withProps"));
var _styles = _interopRequireDefault(require("./styles"));
var _arrow = _interopRequireDefault(require("./arrow.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var GeoTreeItem = function GeoTreeItem(_ref) {
  var open = _ref.open,
    checked = _ref.checked,
    hasActiveChildren = _ref.hasActiveChildren,
    hasChildren = _ref.hasChildren,
    name = _ref.name,
    onClick = _ref.onClick,
    onChange = _ref.onChange;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.wrapper
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: _styles.default.item
  }, /*#__PURE__*/_react.default.createElement("input", {
    checked: checked,
    className: _styles.default.checkbox,
    indeterminate: hasActiveChildren.toString(),
    type: "checkbox",
    onChange: onChange
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.name
  }, name)), hasChildren && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.toggleWrapper
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    width: _Button.WIDTHS.FLUID,
    height: _Button.HEIGHTS.FLUID,
    className: (0, _classnames2.default)(_styles.default.toggle, _defineProperty({}, _styles.default.active, open)),
    icon: _arrow.default,
    theme: _Button.THEMES.TRANSPARENT,
    onClick: onClick
  })));
};
GeoTreeItem.propTypes = {
  checked: _propTypes.default.bool.isRequired,
  hasActiveChildren: _propTypes.default.bool.isRequired,
  hasChildren: _propTypes.default.bool.isRequired,
  name: _propTypes.default.string.isRequired,
  open: _propTypes.default.bool.isRequired,
  onChange: _propTypes.default.func.isRequired,
  onClick: _propTypes.default.func.isRequired
};
var enhancer = R.compose(_withProps.default, _react.memo);
var _default = exports.default = enhancer(GeoTreeItem);